import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Proteins } from 'models/Pet'
import { FrozenRecipeDetail } from 'features/Recipes/FrozenRecipeDetail'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Beef Recipe',
    image: [
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbeef-bowl.70407e05.webp&w=1920&q=75',
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fbeef-ingredients-display.95162b08.webp&w=3840&q=75',
    ],
    description:
      "One of We Feed Raw's best-selling single-protein dog food recipes. Raw beef is a highly nutritious source of essential amino acids, vitamins, and minerals. Formulated by a PhD nutrition expert to be complete + balanced for dogs of all life stages.",
    brand: {
      '@type': 'Brand',
      name: 'We Feed Raw',
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'We Feed Raw',
    },
    url: 'https://wefeedraw.com/recipes/beef',
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Protein',
        value: 'Beef',
      },
      {
        '@type': 'PropertyValue',
        name: 'Beef Quality',
        value: 'Pasture-Raised, Grain-Finished Beef',
      },
      {
        '@type': 'PropertyValue',
        name: 'Antibiotics',
        value: 'Minimally Processed',
      },
      {
        '@type': 'PropertyValue',
        name: 'Harvesting Method',
        value: 'Humanely Harvested',
      },
    ],
    offers: {
      '@type': 'Offer',
      price: '9.66',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'We Feed Raw',
      },
      url: 'https://wefeedraw.com/recipes/beef',
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: '0.00',
          currency: 'USD',
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US',
        },
      },
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '16.10',
          priceCurrency: 'USD',
          priceType: 'ListPrice',
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '9.66',
          priceCurrency: 'USD',
          priceType: 'SalePrice',
        },
      ],
    },
    isRelatedTo: {
      '@type': 'Product',
      name: 'Beef Recipe',
      url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
    },
    isSimilarTo: [
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/chicken',
      },
      {
        '@type': 'Product',
        name: 'Turkey Recipe',
        url: 'https://wefeedraw.com/recipes/turkey',
      },
      {
        '@type': 'Product',
        name: 'Duck Recipe',
        url: 'https://wefeedraw.com/recipes/duck',
      },
      {
        '@type': 'Product',
        name: 'Lamb Recipe',
        url: 'https://wefeedraw.com/recipes/lamb',
      },
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
      },
    ],
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:BEEF.page-title')}</title>
        <meta name="title" content={t('recipes:BEEF.meta-title')} />
        <meta name="description" content={t('recipes:BEEF.meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/beef" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FrozenRecipeDetail protein={Proteins.BEEF} />
      </main>
    </div>
  )
}
